import { axiosInstance } from 'src/util/axios/instance.axios'
import {
  RoleOrganisationOverview,
  RoleOrganisationOverviewOrder,
  RoleOrganisationOverviewSortBy,
  TeamRolesSkillGapMetricsOverview,
  TeamRolesUsersSkillGapMetricsList,
} from '../model/my-team-roles'

export async function getTeamRolesSkillGapMetricsBatch(
  levelIds: string[],
): Promise<TeamRolesSkillGapMetricsOverview> {
  const { data } = await axiosInstance.request<TeamRolesSkillGapMetricsOverview>({
    url: '/my-team/team-roles-skill-gap-metrics',
    method: 'POST',
    data: {
      levelIds,
    },
  })

  return data ?? {}
}

export async function getTeamRolesOrganisationOverview(
  levelId: string,
  skip: number,
  take: number,
  search?: string,
  sortBy?: RoleOrganisationOverviewSortBy,
  order?: RoleOrganisationOverviewOrder,
): Promise<RoleOrganisationOverview> {
  const { data } = await axiosInstance.request<RoleOrganisationOverview>({
    url: '/my-team/team-roles-organisation-overview',
    params: {
      levelId,
      skip,
      take,
      ...(search ? { search } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(order ? { order } : {}),
    },
  })

  return data
}

export async function getTeamRolesUsersSkillGapMetrics(
  levelId: string,
  skip: number,
  take: number,
  search?: string,
  sortBy?: RoleOrganisationOverviewSortBy,
  order?: RoleOrganisationOverviewOrder,
): Promise<TeamRolesUsersSkillGapMetricsList> {
  const { data } = await axiosInstance.request<TeamRolesUsersSkillGapMetricsList>({
    url: '/my-team/team-roles-users-skill-gap-metrics/',
    params: {
      levelId,
      skip,
      take,
      ...(search ? { search } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(order ? { order } : {}),
    },
  })

  return data ?? { users: [], totalUsers: 0, filteredUsers: 0 }
}
